import { lazy } from "react";
import Loadable from "app/components/Loadable";

const DoctorScreen = Loadable(lazy(() => import("./DoctorScreen")));

const QueueBoardRoutes = [
  { path: "/healthcare/queueboard/doctor", element: <DoctorScreen /> },
];

export default QueueBoardRoutes;
